import { useState } from "react";
import { Box } from "@mui/material";
import { widgets } from "../../widgets/config";
import getFavorites from "@arelia-utils/helpers/getFavorites";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { Widget } from "@arelia-types/widget";
import { GridLayout } from "@arelia-components/layout/GridLayout";

export default function DashboardContent() {
  const [favorites, setFavorites] = useState(() => getFavorites());

  // TODO: rewrite storage listener when store will be implemented
  useEventListeners(["storage"], () => setFavorites(getFavorites()));

  let filteredWidgets = widgets.filter((widget) =>
    favorites.length ? favorites.includes(widget.id) : widget.isStandard
  ).sort((a, b) => b.size - a.size);

  return (
    <GridLayout>
      {filteredWidgets.map((widgetConfig: Widget) => {
        const { size, height, component: Component, id } = widgetConfig;

        return (
          <Box key={id}
            gridColumn={`span ${size}`}
            gridRow={`span ${height}`}
          >
            <Component config={widgetConfig} />
          </Box>
        )
      })}
    </GridLayout>
  );
}
